import React from 'react'

const IconMarkerImportant = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M12 3 L22 20 H2 Z' />
         <line x1='12' y1='9' x2='12' y2='14' />
         <circle cx='12' cy='17.2' r='0.9' fill='currentColor' stroke='none' />
      </svg>
   )
}
export default IconMarkerImportant
